import React from 'react';
import { VendorCodeType } from './../../../enums/vendor/VendorCodeTypeEnum';

import './../../../css/vendor/displays/VendorCodeTypeText.css';

type Props = {
  status: VendorCodeType;
};

const VendorCodeTypeText = ({ status }: Props) => {
  switch (status) {
    case VendorCodeType.COMMERCIAL:
      return <span className="VendorCodeTypeCommercial pill">TFN Only</span>;
    case VendorCodeType.INTERNET:
      return <span className="VendorCodeTypeInternet pill">Internet</span>;
    case VendorCodeType.COMMERCIAL_HOME_WARRANTY:
      return <span className="VendorCodeTypeCommercial pill">TFN Only - Home Warranty</span>;
    case VendorCodeType.INTERNET_HOME_WARRANTY:
      return <span className="VendorCodeTypeInternet pill">Internet - Home Warranty</span>;
    default:
      return <span className="VendorCodeTypeNotSet pill">Unknown</span>;
  }
};

export default VendorCodeTypeText;
